import React from "react"

const Tagline = ({text}) => {
  return (
    <div className="tagline">
      <p className="tag">{text}</p>
    </div>
  )
}

export default Tagline
